import { generatePath } from 'react-router-dom';

import { Links } from 'router/links';

export const generateUrlById = (link: Links, id: string): string =>
  generatePath(link, { id, type: null, token: null });

export const generateUrlByType = (link: Links, type: string): string =>
  generatePath(link, { type, id: null, token: null });
